export default () => ({
    labels: {}
})